var jsonData = {
    'list': [
        {
            ocName: '陕西传统手艺', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【封面图】全国春季“村晚”示范展示点“大地欢歌”陕西省乡村文化活动年启动仪式暨安康市“四季村晚”春季示范展演.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/全国春季“村晚”示范展示点“大地欢歌”陕西省乡村文化活动年启动仪式暨安康市“四季村晚”春季示范展演 .mp4',   // 视频链接 
            brief: '4月25日，全国春季“村晚”示范展示——“大地欢歌”陕西省乡村文化活动年启动仪式暨安康市“四季村晚”示范启动发布活动在石泉县明星村成功举办。安康市委常委、宣传部长陈莲，安康市人民政府副市长周耀宜，陕西省文化和旅游厅二级巡视员朱耀勋，陕西省乡村振兴局总规划师张秋侠，省农业农村厅二级调研员朱燕出席活动。', //简介，需要换行的用"KADA" 分割
            time: '2023-04-25', //日期 
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“大地欢歌”西安市乡村文化活动年启动仪式暨西安市蓝田县“四季村晚”示范展示活动', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【封面图】“大地欢歌”西安市乡村文化活动年启动仪式暨西安市蓝田县“四季村晚”示范展示活动.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/“大地欢歌”西安市乡村文化活动年启动仪式暨西安市蓝田县“四季村晚”示范展示活动.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '5月25日，由文化和旅游部主办，文化和旅游部公共服务司、文化和旅游部全国公共文化发展中心、陕西省文化和旅游厅、西安市文化和旅游局、西安市农业农村局、西安市乡村振兴局、中共蓝田县委、蓝田县人民政府承办，由中国文化馆协会、西安市群众艺术馆、中共蓝田县委宣传部、蓝田县文化和旅游体育局、蓝田县九间房镇人民政府、蓝田县文化馆具体实施的“大地欢歌”西安市乡村文化活动年启动仪式暨西安市蓝田县“四季村晚”示范展示活动在蓝田县九间房镇荞麦花海隆重举行。', //简介，需要换行的用"KADA" 分割
            time: '2023-05-25', //日期
            class: '1',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '西安市蓝田具九间房镇岭口村',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 1,
        },
        {
            ocName: '“大地欢歌·四季村晚”全国春季示范展示活动暨榆林市府谷县古韵秧歌文化节启动仪式', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【封面图】“大地欢歌·四季村晚” 全国春季示范展示活动暨榆林市府谷县古韵秧歌文化节.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/府谷村晚 大地村晚.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '5月25日至28日，在庙沟门镇沙梁村举行了文化馆服务宣传周“大地欢歌·四季村晚”全国春季示范展示活动暨榆林市府谷县古韵秧歌文化节启动仪式。启动仪式上，举行了精彩纷呈的文艺表演。参加活动的领导嘉宾们参观了府谷农特产品、地方美食展示和沙梁古镇建设。', //简介，需要换行的用"KADA" 分割
            time: '2023-05-25', //日期
            class: '1',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '榆林市府谷县庙沟门镇沙梁村',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '全国“四季村晚”示范展示点“大地欢歌-- 幸福起航 和美山阳”陕西省山阳县2023年夏季乡村“村晚”示范展示活动', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【封面图】全国“四季村晚”示范展示点陕西省山阳县2023年夏季“村晚”示范展演活动.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/“大地欢歌-- 幸福起航 和美山阳”.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '6月20日上午，全国“四季村晚”示范展示点“大地欢歌-- 幸福起航 和美山阳”陕西省山阳县2023年夏季乡村“村晚”示范展示活动在法官庙村盛大举行。', //简介，需要换行的用"KADA" 分割
            time: '2023-06-20', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '商洛市山阳县法官镇法官庙村',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '留坝县江口镇大地欢歌·四季村晚系列活动——春：看村晚 逛老集 品美食', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/留坝县文化馆.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/留坝县文化馆.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '4月27日上午，留坝县江口镇大地欢歌·四季村晚系列活动——春：看村晚 逛老集 品美食在陕西省汉中市留坝县江口镇红色文化广场上举行。', //简介，需要换行的用"KADA" 分割
            time: '2023-04-27', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '留坝县文化馆',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '太白县庆“五一”国际劳动节文艺汇演', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【封面图】太白县庆“五一”国际劳动节文艺汇演.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/太白县庆“五一”国际劳动节文艺汇演.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '  为充分展示全县广大干部职工主人翁精神和主力军作用，按照“职工欢迎、广泛参与、社会互动、务求实效”的总体要求，以“弘扬劳模精神、建功新时代”为主题，通过全县干部职工丰富多彩的文艺节目表演，在全社会营造“劳动最光荣、劳动最崇高、劳动最伟大、劳动最美丽”的良好社会风尚。', //简介，需要换行的用"KADA" 分割
            time: '2023-05-05', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '太白县文化馆',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 1,
        },
        {
            ocName: '2023年全国夏季“村晚”示范展演暨平利县清凉一夏文旅活动启动仪式', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【平利县封面图】.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/直播回放/【平利县直播】2023年全国夏季“村晚”示范展演暨平利县清凉一夏文旅活动启动仪式.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '7月6日晚“大地欢歌 最美乡村 幸福平利”2023年全国夏季“村晚”示范展演暨平利县“清凉一夏”文旅活动在安康市平利县老县镇蒋家坪村正式启动', //简介，需要换行的用"KADA" 分割
            time: '2023-07-06', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '安康市平利县老县镇蒋家坪村',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“缤纷夏日 畅游咸阳” 2023咸阳市夏季“村晚”示范展演活动', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0814/【咸阳市】封面图.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0814/【咸阳市】“缤纷夏日 畅游咸阳”咸阳市夏季“村晚”示范展演活动~1.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '8月8日晚，“缤纷夏日 畅游咸阳” 2023咸阳市夏季“村晚”示范展演活动在礼泉县袁家村举办。', //简介，需要换行的用"KADA" 分割
            time: '2023-08-08', //日期
            class: '2',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '咸阳市礼泉县烟霞镇袁家村',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省2023年乡村“村晚”暨“如诗如画美家园·西沟村春节晚', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/【封面图】“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省2023年乡村“村晚”暨“如诗如画美家园·西沟村春节晚会.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省2023年乡村“村晚”暨“如诗如画美家园·西沟村春节晚.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '2023年1月13日14:00，陕西省2023年乡村“村晚”暨“如诗如画美家园·西沟村春节晚会"将在安康市汉滨区茨沟镇西沟村正式上演。', //简介，需要换行的用"KADA" 分割
            time: '2023-01-13', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '西沟村村民委员会',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省西安市鄠邑区“村晚”', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/【封面图】“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省西安市鄠邑区“村晚”.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——陕西省西安市鄠邑区“村晚”.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '依托鄠邑区蔡家坡得天独厚的地理环境优势，整合鄠邑区文旅资源，结合实际在蔡家坡举办鄠邑区村晚活动，节目内容以歌舞、曲艺、鼓舞为主，充分展示鄠邑新区发展变化新貌及群众奋发昂扬的精神风貌。', //简介，需要换行的用"KADA" 分割
            time: '2023-01-15', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '西安市鄠邑区人民政府',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——潼关县2023年第二届乡村村晚', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/【封面图】“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——潼关县2023年第二届乡村村晚.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/“启航新征程·幸福中国年”2023年全国“村晚”示范展示活动——潼关县2023年第二届乡村村晚.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '由中共潼关县委宣传部、潼关县文化和旅游局主办，县文化馆、县秦腔剧团承办的“启航新征程 幸福中国年”潼关县2023年第二届乡村村晚活动即将在“云”端精彩亮相。‍‍‍', //简介，需要换行的用"KADA" 分割
            time: '2023-01-14', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '潼关县文化馆',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“文化惠民生 畅享新生活”2023年乾县“四季村晚”演出', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/【封面】2023乾县村晚.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/2023乾县村晚.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '8月31日晚，大地欢歌·全国乡村文化活动年“文化惠民生 畅享新生活”2023年乾县“四季村晚”在乾陵唐佰苑精彩呈现。', //简介，需要换行的用"KADA" 分割
            time: '2023-08-31', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '乾县文化馆',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“文化惠民生 畅享新生活”2023年乾县“四季村晚”演出', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0912/【封面图】大地欢歌2023陕西省群众文化节宝鸡分会场系列活动.jpg', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/0814/大地欢歌2023陕西省群众文化节宝鸡分会场系列活动——全市优秀新编广场舞展演.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '6月29日下午，由宝鸡市文化和旅游局、中共眉县县委、眉县人民政府主办，宝鸡市群众艺术馆、太白山旅游区管委会、眉县文化和旅游局、宝鸡二建集团有限公司承办，各县区文化馆协办的“大地欢歌”2023陕西省群众文化节宝鸡分会场系列活动——全市优秀新编广场舞展演在太白山旅游区龙凤广场举办。', //简介，需要换行的用"KADA" 分割
            time: '2023-06-29', //日期
            class: '5',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '眉县文化馆',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
        {
            ocName: '“茶乡庆丰收 民歌颂党恩”2023年全国秋季“村晚”示范展演暨农民丰收节文旅活动启动仪式', //标题
            cover: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/1016/【封面汉中市】2023年全国秋季“村晚”示范展演暨农民丰收节文旅活动启动仪式.png', // 封面图   
            url: 'https://shaanxi.kadadx.com/file/陕西省文化馆/享活动/1016/【汉中市】直播2023全国村晚镇巴 .mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '10月7日晚，2023年全国秋季“村晚”示范展演暨农民丰收节文旅活动启动仪式在陕西省汉中市镇巴县兴隆镇水田坝社区成功举办，吸引了当地近两千名观众观看。', //简介，需要换行的用"KADA" 分割
            time: '2023-10-7', //日期
            class: '3',  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '汉中市镇巴县兴隆镇水田坝社区',//报送单位
            ocVote: 3936,
            standby1: '',//备用1 
            flag: 0,
        },
    ]
}
export default jsonData


// WEBPACK FOOTER //
// ./src/api/datalist.js